import { useTranslation } from 'react-i18next';
import { FormProvider } from 'react-hook-form';
import { Heading, Text } from '@lili/lili-frontend-common';
import { StepPageWrapper } from '@Layout/StepPageWrapper.tsx';
import { useIdentityLogic } from '@Pages/happyFlowPages/identity/hooks/useIdentityLogic.ts';
import {
  IdentityFormTypes,
  IdentityFormTypeSwitcher,
} from '@Components/Identity/IdentityFormTypeSwitcher';
import { IdentityUsForm } from '@Pages/happyFlowPages/identity/identityForm/us/IdentityUsForm.tsx';
import { useGetCountries } from '@Hooks/api/useGetCountries';
import { RoutesMap } from '@Router/router.types';

interface IdentityProps {
  originRoute?: RoutesMap;
}

export const Identity = ({ originRoute = RoutesMap.IDENTITY }: IdentityProps) => {
  const { t } = useTranslation();
  useGetCountries(true, false);

  const {
    isPending,
    selectedCountry,
    countryDataList,
    handleSubmit,
    formMethods,
    formType,
    isNonUsSupported,
    isPhoneCountryCodeUs,
    handleFormTypeChange,
    editMode,
  } = useIdentityLogic(originRoute);

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isPending}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        heading={t('sectionTitles.personalDetails')}
        content={t('pages.identity.subtitle')}>
        <div className='w-full h-full flex flex-col'>
          {isNonUsSupported ? (
            <IdentityFormTypeSwitcher
              isSwitchDisabled={isPending || editMode}
              formMethods={formMethods}
              selectedCountry={selectedCountry}
              countryDataList={countryDataList}
              isUsTabAllowed={isPhoneCountryCodeUs}
              formType={formType}
              onFormTypeChanged={handleFormTypeChange}
            />
          ) : (
            <IdentityUsForm />
          )}
          <div className='mt-auto'>
            {formType === IdentityFormTypes.nonUs && (
              <Heading.H10 className='text-text-main-tertiary mb-[16px]'>
                {t('pages.nonUsIdentity.disclaimerOwner')}
              </Heading.H10>
            )}
            <Text.H10 className='text-text-main-tertiary whitespace-pre-line pb-[22px]'>
              {t('pages.identity.information')}
            </Text.H10>
          </div>
        </div>
      </StepPageWrapper>
    </FormProvider>
  );
};
